import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiEye, FiInbox } from 'react-icons/fi';
import { CustomerCenterService } from "../../../services";
import TopSetion from '../../../components/customer-service-center/TopSetion';
import SubHeading from '../../../components/customer-service-center/SubHeading';
import { formatDateToYYYYMMDD } from '../../../utils/dateUtils';
import defaultNewsImage from '../../../assets/img/customer-service-center/news-default-img.gif';



// Utility function to format content and remove images
const formatContent = (htmlContent) => {
    if (!htmlContent) return '';

    // Create a temporary div to parse HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    // Remove all img tags
    const images = tempDiv.querySelectorAll('img');
    images.forEach(img => img.remove());

    // Get the text content and format it
    let textContent = tempDiv.textContent || tempDiv.innerText || '';

    // Clean up extra whitespace and line breaks
    textContent = textContent
        .replace(/\s+/g, ' ') // Replace multiple spaces with single space
        .replace(/\n\s*\n/g, '\n') // Replace multiple line breaks with single
        .trim();

    // Limit the content length for preview (e.g., 150 characters)
    if (textContent.length > 90) {
        textContent = textContent.substring(0, 90) + '...';
    }

    return textContent;
};

const MemorialNewsList = () => {
    const navigate = useNavigate();
    const [memorialNewsList, setMemorialNewsList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [visibleCount, setVisibleCount] = useState();
    const [hasMore, setHasMore] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const fetchMemorialNewsList = async (page = currentPage, append = false) => {
        try {
            setLoading(true);
            const apiData = await CustomerCenterService.getMemorialNewsList({
                page: page,
                size: 4,
            });
            if (apiData.content.length > 0) {
                // Check for duplicate boardId before setting announcements
                const uniqueMemorialNewsList = [];
                const seenBoardIds = new Set();

                // If appending, add existing announcements to the set
                if (append) {
                    memorialNewsList.forEach(item => seenBoardIds.add(item.id));
                }

                for (const item of apiData.content) {
                    if (!seenBoardIds.has(item.id)) {
                        uniqueMemorialNewsList.push(item);
                        seenBoardIds.add(item.id);
                    }
                }

                if (append) {
                    setMemorialNewsList(prev => [...prev, ...uniqueMemorialNewsList]);
                } else {
                    setMemorialNewsList(uniqueMemorialNewsList);
                }
            }
            setTotalPages(apiData.totalPages);
        } catch (err) {
            console.error('Failed to fetch announcements:', err);
            setError('공지사항을 불러오는데 실패했습니다. 잠시 후 다시 시도해주세요.');
        } finally {
            setLoading(false);
        }
    };

    // Simulate API call
    useEffect(() => {
        fetchMemorialNewsList();
    }, []);

    const handleLoadMore = () => {
        if (currentPage < totalPages) {
            const nextPage = currentPage + 1;
            setCurrentPage(nextPage);
            fetchMemorialNewsList(nextPage, true); // Append new announcements
        }
    };


    const handleMemorialNewsClick = (memorialNewsId) => {
        navigate(`/memorial-news/${memorialNewsId}`);
    };

    return (

        <>
            <div className="announcement-list-page">

                <TopSetion />

                {/* Main Content */}
                <main className="main-content">

                    <SubHeading heading="추모원 소식" />


                    {/* Announcement Section */}
                    <section className="announcement-section">
                        {loading && memorialNewsList.length === 0 ? (
                            <div className="loading-container">
                                <div className="loading-spinner"></div>
                                <p>추모원 소식을 불러오는 중...</p>
                            </div>
                        ) : memorialNewsList.length === 0 ? (
                            <div className="empty-state">
                                <FiInbox className="empty-icon" size={64} />
                                <div className="empty-title">등록된 공지사항이 없습니다</div>
                                <div className="empty-description">
                                    새로운 공지사항이 등록되면 이곳에 표시됩니다.
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="announcement-grid memorial-news-grid">
                                    {memorialNewsList.map((memorialNews) => (
                                        <div
                                            key={memorialNews.id}
                                            className="announcement-card clickable"
                                            onClick={() => handleMemorialNewsClick(memorialNews.id)}
                                        >
                                            <div className="announcement-image">
                                                <img
                                                    src={defaultNewsImage}
                                                    alt={memorialNews.title}
                                                    onError={(e) => {
                                                        e.target.src = defaultNewsImage;
                                                    }}
                                                />
                                            </div>
                                            <div className="announcement-content">
                                                <h3 className="announcement-title">
                                                    {memorialNews.title}
                                                </h3>
                                                <p className="announcement-description">
                                                    {formatContent(memorialNews.contents)}
                                                </p>
                                                <div className="announcement-meta">
                                                    <span className="announcement-date">
                                                        {formatDateToYYYYMMDD(memorialNews.registTime)}
                                                    </span>
                                                    <span className="announcement-views">
                                                    <FiEye className="eye-icon" />
                                                        {memorialNews.readCount}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Load More Button */}
                                {currentPage < totalPages && (
                                    <div className="more-button-section">
                                        <button
                                            className="more-button"
                                            onClick={handleLoadMore}
                                        >
                                            더보기
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </section>
                </main>
            </div>
        </>
    );
};

export default MemorialNewsList;